<template>
  <div class="item-box-content mainStep" style="min-height:632px">
    <div class="title-font-style">
      <span>合同管理</span>
    </div>

    <!-- 未生成合同 -->
    <div v-if="contactStatus ===0">
      <div class="maintain-scheme">
        <span style="vertical-align: 0px;margin-right: 5px;">
          <svg
            t="1599634792304"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2406"
            width="26"
            height="26"
          >
            <path
              d="M265.6 411.904a52.8128 52.8128 0 1 0 105.6 0 52.8128 52.8128 0 0 0-105.6 0z m387.2 0a52.8128 52.8128 0 1 0 105.6 0 52.8128 52.8128 0 0 0-105.6 0zM512 19.2C239.872 19.2 19.2 239.872 19.2 512S239.872 1004.8 512 1004.8 1004.8 784.128 1004.8 512 784.128 19.2 512 19.2zM801.28 801.28a409.2416 409.2416 0 0 1-130.0992 87.808A405.0688 405.0688 0 0 1 512 921.1904 407.4496 407.4496 0 0 1 222.592 801.28 406.9376 406.9376 0 0 1 102.784 512 407.4496 407.4496 0 0 1 222.72 222.592 406.9376 406.9376 0 0 1 512 102.784 407.4496 407.4496 0 0 1 801.408 222.72a406.9376 406.9376 0 0 1 119.808 289.28 406.016 406.016 0 0 1-32.1024 159.3088A405.76 405.76 0 0 1 801.28 801.28zM512 535.1168c-94.0544 0-171.1616 74.0352-176 166.7584a8.7808 8.7808 0 0 0 8.8064 9.2416h52.9152c4.608 0 8.576-3.5072 8.9088-8.1408a105.728 105.728 0 0 1 210.7648 0c0.3072 4.608 4.2752 8.1408 8.8832 8.1408h52.9152a8.7808 8.7808 0 0 0 8.8064-9.216c-4.864-92.7488-81.9456-166.784-176-166.784z"
              p-id="2407"
              fill="#999999"
            />
          </svg>
        </span>
        {{'合同未生成，请根据需求选择是否生成退货合同'}}
      </div>

      <el-button style="margin-top:20px;" @click="addReturnContrct" type="primary">生成退货合同</el-button>
    </div>
    <!-- 待签署 -->
    <div v-if="contactStatus===1">
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同编号：">{{params.retreatContractNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发起时间：">{{params.createDate|dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-steps align-center :active="2" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="合同生成" icon="el-icon-success"></el-step>
          <el-step title="待签署" icon="el-icon-success"></el-step>
          <el-step title="上传盖章合同" icon="el-icon-success"></el-step>
          <el-step title="上级审批中" icon="el-icon-success"></el-step>
          <el-step title="审批通过" icon="el-icon-success"></el-step>
        </el-steps>
      </div>
      <div style="margin-top:20px;">
        <el-button @click="updateContractDown" type="primary">下载退货合同</el-button>
        <el-button @click="onContractSealUpload">上传签署合同</el-button>
        <el-button @click="updateContractContrct">合同作废</el-button>
      </div>
    </div>

    <!-- 审核中 -->
    <div v-if="contactStatus===2">
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同编号：">{{params.retreatContractNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发起时间：">{{params.createDate|dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-steps align-center :active="4" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="合同生成" icon="el-icon-success"></el-step>
          <el-step title="待签署" icon="el-icon-success"></el-step>
          <el-step title="上传盖章合同" icon="el-icon-success"></el-step>
          <el-step title="上级审批中" icon="el-icon-success"></el-step>
          <el-step title="审批通过" icon="el-icon-success"></el-step>
        </el-steps>
      </div>

      <return-data :titleText="`请等待上级审批`"></return-data>
    </div>
    <!-- 审核失败 -->
    <div v-if="contactStatus ===4">
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同编号：">{{params.retreatContractNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发起时间：">{{params.createDate|dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div>
        <el-steps align-center :active="5" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="合同生成" icon="el-icon-success"></el-step>
          <el-step title="待签署" icon="el-icon-success"></el-step>
          <el-step title="上传盖章合同" icon="el-icon-success"></el-step>
          <el-step title="上级审批中" icon="el-icon-success"></el-step>
          <el-step style="color:red;" title="审批失败" icon="el-icon-error"></el-step>
        </el-steps>
      </div>
      <div style="margin-top:20px;">
        <el-button @click="updateContractDown" type="primary">下载退货合同</el-button>
        <el-button @click="onContractSealUpload">上传签署合同</el-button>
        <el-button @click="updateContractContrct">合同作废</el-button>
      </div>
      <div class="title-text">
        <span class="text-title">{{"说明：如产品调整或结算方式调整需重新上传合同，请合同作废后重新生成"}}</span>
      </div>
    </div>
    <!-- 审核通过 -->
    <div v-if="contactStatus ===3">
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同编号：">{{params.retreatContractNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发起时间：">{{params.createDate|dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div>
        <el-steps align-center :active="5" style="margin:auto;padding:20px;margin-top:20px; ">
          <el-step title="合同生成" icon="el-icon-success"></el-step>
          <el-step title="待签署" icon="el-icon-success"></el-step>
          <el-step title="上传盖章合同" icon="el-icon-success"></el-step>
          <el-step title="上级审批中" icon="el-icon-success"></el-step>
          <el-step style="color:red;" title="审批通过" icon="el-icon-success"></el-step>
        </el-steps>
      </div>
      <div style="margin-top:20px;">
        <el-button @click="updateContractDown" type="primary">下载已签署合同</el-button>
        <el-button @click="updateContractContrct">合同作废</el-button>
      </div>
      <div class="title-text">
        <span class="text-title">{{"说明：如产品调整或结算方式调整需重新上传合同，请合同作废后重新生成"}}</span>
      </div>
    </div>
    <!-------------- 盖章合同上传 -------------->
    <sealed-contract-upload v-if="isShow" ref="sealedContractUploadRefs"></sealed-contract-upload>
  </div>
</template>
<script>
import { formatDate, uploadDown } from '@/util/tool'
import { queryContract } from '@/api/purchase/purchaseManage'

import sealedContractUpload from '../../../../sell/personageManagement/components/contractList/sealedContractUpload'
import returnData from '@/components/returnData'
import {
  queryNotProducePage, addRetreatContract, updateContract, queryUploadPrP
} from '@/api/purchase/purchasePlanList'
export default {
  components: {
    'sealed-contract-upload': sealedContractUpload,
    'return-data': returnData

  },
  data () {
    return {
      isShow: false,
      contactStatus: 0,
      queryParams: {},
      params: {}
    }
  },
  mounted () { },
  methods: {
    queryContract () {
      queryContract(this.params.id, 3).then((res) => {
        if (res.data.code === 200) {
          this.dataList = res.data.obj
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    getList (type) {
      queryNotProducePage(this.$route.query.pcrId).then((res) => {
        if (res.data.code === 200) {
          this.isShow = false
          if (type === 1) {
            this.onContractSealUpload()
          } else if (type === 2) {
            this.isShow = false
          }
          this.queryParams = res.data.obj
          this.params = res.data.obj.purchaseRetreatPact
          this.contactStatus = res.data.obj.purchaseRetreatManageVo.purchaseRetreatContractVo.contractState
        } else {
          this.$message.error(res.data.msg)
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // 生成退货合同
    addReturnContrct () {
      addRetreatContract(this.queryParams).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('退货合同生成成功！')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // 合同作废
    updateContractContrct () {
      updateContract(this.params.id).then((res) => {
        if (res.data.code === 200) {
          this.isShow = false
          this.$message.success('合同作废成功！')
          this.getList()
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // 下载合同
    updateContractDown () {
      queryUploadPrP(this.params.id).then((res) => {
        if (res.data.code === 200) {
          uploadDown(
            this.$store.state.https + res.data.obj.fileUrl,
            this.params.retreatContractNumber
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onContractSealUpload () {
      this.isShow = true
      this.$nextTick(data => {
        this.$refs.sealedContractUploadRefs.getList(
          this.params.id,
          3
        )
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.maintain-scheme {
  height: 100px;
  background: rgba(243, 247, 255, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 100px;
  margin-top: 20px;
  color: #999999;
}
.title-text {
  margin: 20px 0 14px;
  .text-title {
    // margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
</style>
